/**
 * Khan Dry Fruit Reels — lazy shoppable Cloudflare Stream rail.
 * Primary feed: GET /api/mobile-reels/shopify (falls back to /api/mobile-reels).
 * ATC: Shopify /cart/add.js + theme cart drawer events.
 */
(function () {
  "use strict";

  var MONEY_FMT = null;
  try {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      MONEY_FMT = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: Shopify.currency.active,
        maximumFractionDigits: 0,
      });
    }
  } catch (e) {}

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return "";
    if (MONEY_FMT) return MONEY_FMT.format(n / 100);
    return "Rs. " + Math.round(n / 100).toLocaleString("en-PK");
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function absUrl(path, apiOrigin) {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    var base = (apiOrigin || "").replace(/\/$/, "");
    return base + (path.charAt(0) === "/" ? path : "/" + path);
  }

  function normalizeCfHost(raw, fallbackHost) {
    var v = (raw || "").trim();
    if (!v) return fallbackHost;
    v = v.replace(/^https?:\/\//i, "").replace(/\/$/, "");
    if (/cloudflarestream\.com/i.test(v)) return v;
    if (/^customer-/i.test(v)) {
      return /\.cloudflarestream\.com$/i.test(v) ? v : v + ".cloudflarestream.com";
    }
    if (/^[a-f0-9]{32}$/i.test(v)) return fallbackHost;
    return "customer-" + v + ".cloudflarestream.com";
  }

  function buildPlaybackFromRaw(reel, cfHost) {
    var host = normalizeCfHost(reel.cfAccountId || reel.cf_account_id, cfHost);
    var id = (reel.cfStreamId || reel.cf_stream_id || "").trim();
    var direct = (reel.directVideoUrl || reel.direct_video_url || "").trim() || null;
    var poster = reel.thumbnailUrl || reel.thumbnail_url || null;
    if (poster && !/^https?:\/\//i.test(poster)) {
      poster = null;
    }
    if (!poster && id && host) {
      poster = "https://" + host + "/" + id + "/thumbnails/thumbnail.jpg?time=1s&height=720";
    }
    var iframe =
      id && host
        ? "https://" +
          host +
          "/" +
          id +
          "/iframe?muted=true&loop=true&autoplay=true&controls=false&preload=metadata" +
          (poster ? "&poster=" + encodeURIComponent(poster) : "")
        : null;
    var mp4 = id && host ? "https://" + host + "/" + id + "/downloads/default.mp4" : null;
    var hls = id && host ? "https://" + host + "/" + id + "/manifest/video.m3u8" : null;
    return {
      directVideoUrl: direct,
      mp4Url: mp4,
      iframeUrl: iframe,
      hlsUrl: hls,
      poster: poster,
      prefer: direct ? "mp4" : mp4 ? "mp4-cf" : iframe ? "iframe" : "none",
    };
  }

  function parseHandleFromCta(ctaUrl) {
    if (!ctaUrl) return null;
    try {
      var path = /^https?:\/\//i.test(ctaUrl) ? new URL(ctaUrl).pathname : ctaUrl;
      var m = path.match(/\/products\/([^\/\?#]+)/i);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function normalizeItems(payload, cfg) {
    var list = [];
    if (payload && Array.isArray(payload.items)) list = payload.items;
    else if (Array.isArray(payload)) list = payload;
    else return [];

    return list
      .map(function (reel) {
        if (reel && reel.playback) {
          var handle =
            (reel.product && reel.product.shopifyHandle) ||
            parseHandleFromCta(reel.ctaUrl) ||
            null;
          return {
            id: reel.id,
            title: reel.title || "Khan Dry Fruit",
            description: reel.description || "",
            ctaLabel: reel.ctaLabel || cfg.atcLabel || "Add to Cart",
            playback: reel.playback,
            product: handle
              ? Object.assign({}, reel.product || {}, { shopifyHandle: handle })
              : reel.product || null,
          };
        }
        var playback = buildPlaybackFromRaw(reel, cfg.cfHost);
        var handle =
          parseHandleFromCta(reel.ctaUrl || reel.cta_url) ||
          null;
        return {
          id: reel.id,
          title: reel.title || "Khan Dry Fruit",
          description: reel.description || "",
          ctaLabel: reel.ctaLabel || reel.cta_label || cfg.atcLabel || "Add to Cart",
          playback: playback,
          product: handle
            ? {
                shopifyHandle: handle,
                name: reel.title,
                image: playback.poster,
              }
            : null,
        };
      })
      .filter(function (r) {
        return r.playback && r.playback.prefer !== "none";
      })
      .slice(0, cfg.limit);
  }

  function fetchJson(url, timeoutMs) {
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var t = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, timeoutMs || 8000);
    return fetch(url, {
      credentials: "omit",
      signal: ctrl ? ctrl.signal : undefined,
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        if (!r.ok) throw new Error("bad status " + r.status);
        return r.json();
      })
      .finally(function () {
        clearTimeout(t);
      });
  }

  function loadProduct(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (r) {
      if (!r.ok) throw new Error("product " + handle);
      return r.json();
    });
  }

  function productHandleOf(p) {
    if (!p) return "";
    return String(p.shopifyHandle || p.shopify_handle || p.handle || "").trim();
  }

  function mapCatalogProduct(p) {
    if (!p || !p.handle) return null;
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || "";
    if (img && img.indexOf("//") === 0) img = "https:" + img;
    return {
      shopifyHandle: p.handle,
      name: p.title || p.handle,
      image: img || null,
    };
  }

  function loadCatalogProducts(limit) {
    var urls = [
      "/collections/all/products.json?limit=" + (limit || 40),
      "/products.json?limit=" + (limit || 40),
    ];
    function tryUrl(i) {
      if (i >= urls.length) return Promise.resolve([]);
      return fetchJson(urls[i], 5000)
        .then(function (data) {
          var list = (data && data.products) || [];
          return list
            .map(mapCatalogProduct)
            .filter(function (p) {
              return p && p.shopifyHandle;
            });
        })
        .catch(function () {
          return tryUrl(i + 1);
        });
    }
    return tryUrl(0);
  }

  function scoreProductMatch(reelTitle, productName) {
    var a = String(reelTitle || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .split(/\s+/)
      .filter(function (w) {
        return w.length > 2 && !/^(khan|dry|fruit|fruits|reel|pack|with|from|our|the|and)$/.test(w);
      });
    var b = String(productName || "").toLowerCase();
    var score = 0;
    for (var i = 0; i < a.length; i++) {
      if (b.indexOf(a[i]) !== -1) score += 1;
    }
    return score;
  }

  function assignDynamicProducts(items, catalog) {
    if (!items || !items.length) return items;
    catalog = catalog || [];
    var used = {};
    items.forEach(function (item, index) {
      var existing = [];
      if (Array.isArray(item.products) && item.products.length) {
        existing = item.products
          .map(function (p) {
            var handle = productHandleOf(p);
            return handle
              ? Object.assign({}, p, { shopifyHandle: handle, name: p.name || p.title || handle, image: p.image || null })
              : null;
          })
          .filter(Boolean);
      } else if (item.product && productHandleOf(item.product)) {
        var h = productHandleOf(item.product);
        existing = [
          Object.assign({}, item.product, {
            shopifyHandle: h,
            name: item.product.name || item.product.title || h,
          }),
        ];
      }
      if (existing.length) {
        item.products = existing;
        item.product = existing[0];
        used[existing[0].shopifyHandle] = true;
        return;
      }
      if (!catalog.length) {
        item.products = [];
        item.product = null;
        return;
      }
      var best = null;
      var bestScore = -1;
      for (var i = 0; i < catalog.length; i++) {
        var cand = catalog[i];
        if (!cand || !cand.shopifyHandle) continue;
        var score = scoreProductMatch(item.title || item._displayTitle, cand.name);
        if (used[cand.shopifyHandle]) score -= 0.35;
        // slight preference by reel index for variety
        score += ((index + i) % catalog.length === 0 ? 0.05 : 0);
        if (score > bestScore) {
          bestScore = score;
          best = cand;
        }
      }
      if (!best) best = catalog[index % catalog.length];
      if (best) {
        used[best.shopifyHandle] = true;
        item.products = [best];
        item.product = best;
      }
    });
    return items;
  }

  function pickVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function productImage(product, fallback) {
    if (!product) return fallback || "";
    if (product.featured_image) {
      return typeof product.featured_image === "string"
        ? product.featured_image
        : product.featured_image.src || fallback || "";
    }
    if (product.images && product.images.length) {
      var img = product.images[0];
      return typeof img === "string" ? img : img.src || fallback || "";
    }
    return fallback || "";
  }

  function openCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent("kdf:cart:updated"));
    } catch (e) {}
    if (typeof window.forceOpenCart === "function") return window.forceOpenCart();
    if (typeof window.openBasket === "function") return window.openBasket();
    if (typeof window.openKdfDrawer === "function") return window.openKdfDrawer();
  }

  function canPlayHlsNatively(video) {
    return video.canPlayType("application/vnd.apple.mpegurl") !== "";
  }

  function KdfReels(root) {
    this.root = root;
    this.cfg = {
      apiUrl: root.getAttribute("data-api-url") || "",
      fallbackApiUrl: root.getAttribute("data-fallback-api-url") || "",
      apiOrigin: root.getAttribute("data-api-origin") || "https://api.khanbabadryfruits.com",
      cfHost: normalizeCfHost(
        root.getAttribute("data-cf-host") || "customer-1xj35z217cmgxlz0.cloudflarestream.com",
        "customer-1xj35z217cmgxlz0.cloudflarestream.com"
      ),
      staticFeedUrl: root.getAttribute("data-static-feed") || "",
      limit: Math.min(Math.max(parseInt(root.getAttribute("data-limit") || "12", 10) || 12, 1), 8),
      atcLabel: root.getAttribute("data-atc-label") || "Add to Cart",
      moneyFormat: root.getAttribute("data-money-format") || "",
    };
    this.track = qs(root, "[data-kdf-reels-track]");
    this.skel = qs(root, "[data-kdf-reels-skel]");
    this.prevBtn = qs(root, "[data-kdf-reels-prev]");
    this.nextBtn = qs(root, "[data-kdf-reels-next]");
    this.cards = [];
    this.activeIndex = 0;
    this.muted = true;
    this.io = null;
    this.nearIo = null;
    this.raf = 0;
    this.destroyed = false;
  }

  KdfReels.prototype.init = function () {
    var self = this;
    var blocksJson = "";
    var blocksNode = qs(this.root, "[data-kdf-reels-blocks]");
    if (blocksNode) blocksJson = blocksNode.textContent || "";
    var blockItems = [];
    if (blocksJson) {
      try {
        blockItems = JSON.parse(blocksJson) || [];
      } catch (e) {
        blockItems = [];
      }
    }

    // Root-cause fix for the 8-10s blank/mixed reels: the live API almost always
    // answers empty (streamConfigured:false, count:0) yet the old code waited for
    // its full timeout chain before showing anything. The static CDN feed is the
    // reliable source, so render from whichever source yields items FIRST; the
    // slower source only merges in when it arrives.
    var rendered = false;
    var renderedIds = {};
    var apiSettled = false;
    var staticSettled = false;

    function blockFallbackItems() {
      if (!blockItems.length) return [];
      return normalizeItems(
        {
          items: blockItems.map(function (b, i) {
            return {
              id: "block-" + i,
              title: b.title || "Khan Dry Fruit",
              ctaLabel: self.cfg.atcLabel,
              ctaUrl: b.product_handle ? "/products/" + b.product_handle : null,
              playback: buildPlaybackFromRaw(
                {
                  cfStreamId: b.cf_stream_id,
                  cfAccountId: b.cf_account_id || self.cfg.cfHost,
                  directVideoUrl: b.video_url,
                  thumbnailUrl: b.poster,
                },
                self.cfg.cfHost
              ),
              product: b.product_handle
                ? {
                    shopifyHandle: b.product_handle,
                    name: b.title,
                    image: b.poster || null,
                  }
                : null,
            };
          }),
        },
        self.cfg
      );
    }

    // Product catalog enriches "shop now" links; never let it gate rendering.
    function withCatalog(items, done) {
      var settled = false;
      function finish(catalog) {
        if (settled) return;
        settled = true;
        self._catalog = catalog || [];
        done(items);
      }
      loadCatalogProducts(24).then(finish, function () {
        finish([]);
      });
      setTimeout(function () {
        finish(self._catalog || []);
      }, 1200);
    }

    function renderNow(items) {
      if (rendered) return;
      rendered = true;
      if ((!items || !items.length) && blockItems.length) {
        items = blockFallbackItems();
      }
      if (!items || !items.length) {
        self.hide();
        return;
      }
      items.forEach(function (it) {
        if (it && it.id) renderedIds[it.id] = true;
      });
      withCatalog(items, function (finalItems) {
        assignDynamicProducts(finalItems, self._catalog || []);
        self.render(finalItems);
      });
    }

    function mergeLiveItems(liveItems) {
      var fresh = (liveItems || []).filter(function (it) {
        return it && it.id && !renderedIds[it.id];
      });
      if (!fresh.length) return;
      fresh.forEach(function (it) {
        renderedIds[it.id] = true;
      });
      var merged = (self._renderedItems || []).concat(fresh);
      var keepScroll = self.track ? self.track.scrollLeft : 0;
      withCatalog(merged, function (finalItems) {
        assignDynamicProducts(finalItems, self._catalog || []);
        self.render(finalItems);
        if (self.track) self.track.scrollLeft = keepScroll;
      });
    }

    function isLivePayload(payload, items) {
      var src = (payload && payload.source) || null;
      return !!(
        items &&
        items.length &&
        (!src || src.cloudflareAuto > 0 || src.mobileReels > 0 || src.streamConfigured === true)
      );
    }

    // Static CDN feed: primary source. Live API: short leash, enhancement only.
    var staticPromise = this.cfg.staticFeedUrl
      ? fetchJson(this.cfg.staticFeedUrl, 6000).catch(function () {
          return { ok: false, items: [] };
        })
      : Promise.resolve({ ok: false, items: [] });

    var apiPromise = this.cfg.apiUrl
      ? fetchJson(this.cfg.apiUrl, 2500).catch(function () {
          return self.cfg.fallbackApiUrl
            ? fetchJson(self.cfg.fallbackApiUrl, 2000).catch(function () {
                return { ok: false, items: [] };
              })
            : { ok: false, items: [] };
        })
      : Promise.resolve({ ok: false, items: [] });

    staticPromise.then(function (payload) {
      staticSettled = true;
      var items = normalizeItems(payload, self.cfg);
      if (items && items.length) {
        renderNow(items);
      } else if (apiSettled && !rendered) {
        renderNow([]);
      }
    });

    apiPromise.then(function (payload) {
      apiSettled = true;
      var items = normalizeItems(payload, self.cfg);
      if (isLivePayload(payload, items)) {
        if (!rendered) renderNow(items);
        else mergeLiveItems(items);
      } else if (staticSettled && !rendered) {
        renderNow([]);
      }
    });
  };

  KdfReels.prototype.hide = function () {
    this.root.hidden = true;
    this.root.setAttribute("aria-hidden", "true");
    if (this.skel) this.skel.hidden = true;
  };

  function prettyTitle(raw, index) {
    var t = String(raw || "").trim();
    if (!t || /^khan dry fruit/i.test(t) || /^reel\s*\d+/i.test(t) || /^\d+(\.mp4)?$/i.test(t)) {
      var labels = [
        "Fresh from our store",
        "Premium gift boxes",
        "Dates & dry fruits",
        "Packed with care",
        "Taste the quality",
        "Handpicked nuts",
        "Ramadan favorites",
        "Family treats",
      ];
      return labels[index % labels.length];
    }
    return t.replace(/\.mp4$/i, "");
  }

  KdfReels.prototype.render = function (items) {
    var self = this;
    if (this.skel) this.skel.hidden = true;
    this.root.hidden = false;
    this.root.removeAttribute("aria-hidden");
    this.track.innerHTML = "";

    // Hard cap for homepage speed (posters + media)
    items = (items || []).slice(0, Math.min(Math.max(this.cfg.limit || 8, 4), 8));
    this._renderedItems = items;

    var html = items
      .map(function (item, index) {
        var title = prettyTitle(item.title, index);
        item._displayTitle = title;
        var poster = (item.playback && item.playback.poster) || "";
        // Prefer smaller CF thumbs for speed
        if (poster && poster.indexOf("thumbnails/thumbnail.jpg") !== -1 && poster.indexOf("height=") === -1) {
          poster += (poster.indexOf("?") === -1 ? "?" : "&") + "height=480";
        } else if (poster && /height=\d+/.test(poster)) {
          poster = poster.replace(/height=\d+/, "height=480");
        }
        var products =
          Array.isArray(item.products) && item.products.length
            ? item.products.filter(function (p) {
                return p && p.shopifyHandle;
              })
            : item.product && item.product.shopifyHandle
              ? [item.product]
              : [];
        item._products = products;
        var hasProduct = products.length > 0;
        var cat = item.linkedCategory && item.linkedCategory.url ? item.linkedCategory : null;
        var primary = products[0];
        var posterTag = poster
          ? index < 2
            ? '<img class="kdf-reels__poster" src="' +
              escapeAttr(poster) +
              '" alt="' +
              escapeAttr(title) +
              '" decoding="async" width="480" height="854" fetchpriority="' +
              (index === 0 ? "high" : "low") +
              '">'
            : '<img class="kdf-reels__poster" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src="' +
              escapeAttr(poster) +
              '" alt="' +
              escapeAttr(title) +
              '" decoding="async" width="480" height="854" loading="lazy">'
          : '<div class="kdf-reels__poster" aria-hidden="true"></div>';

        var chips =
          products.length > 1
            ? '<div class="kdf-reels__chips" data-kdf-chips role="tablist" aria-label="Products">' +
              products
                .map(function (p, pi) {
                  return (
                    '<button type="button" class="kdf-reels__chip' +
                    (pi === 0 ? " is-on" : "") +
                    '" data-kdf-chip data-pi="' +
                    pi +
                    '" role="tab" aria-selected="' +
                    (pi === 0 ? "true" : "false") +
                    '">' +
                    (p.image
                      ? '<img src="' +
                        escapeAttr(p.image) +
                        '" alt="" width="28" height="28" loading="lazy" decoding="async">'
                      : "") +
                    "<span>" +
                    escapeHtml((p.name || "Item").split(" ").slice(0, 2).join(" ")) +
                    "</span></button>"
                  );
                })
                .join("") +
              "</div>"
            : "";

        var productBlock = hasProduct
          ? chips +
            '<div class="kdf-reels__product is-dynamic is-compact" data-kdf-product data-handle="' +
            escapeAttr(primary.shopifyHandle) +
            '">' +
            '<a class="kdf-reels__product-link" href="/products/' +
            escapeAttr(primary.shopifyHandle) +
            '" aria-label="View product">' +
            '<img class="kdf-reels__product-img" data-kdf-product-img alt="" width="44" height="44" loading="lazy" decoding="async">' +
            '<span class="kdf-reels__product-copy">' +
            '<span class="kdf-reels__product-name" data-kdf-product-name>' +
            escapeHtml(primary.name || title) +
            "</span>" +
            '<span class="kdf-reels__price-row">' +
            '<span class="kdf-reels__price" data-kdf-price></span>' +
            '<span class="kdf-reels__compare" data-kdf-compare hidden></span>' +
            "</span></span></a>" +
            '<div class="kdf-reels__actions">' +
            '<button type="button" class="kdf-reels__atc" data-kdf-atc>' +
            escapeHtml(shortAtcLabel(item.ctaLabel)) +
            "</button>" +
            '<button type="button" class="kdf-reels__buy" data-kdf-buy aria-label="Buy now">Buy</button>' +
            "</div></div>"
          : "";

        var catBlock = cat
          ? '<a class="kdf-reels__cat" href="' +
            escapeAttr(cat.url) +
            '">Shop ' +
            escapeHtml(cat.name || "category") +
            "</a>"
          : "";

        // Keep Open Reels only as last-resort when no product could be linked.
        var fallbackBlock =
          !hasProduct && !cat
            ? '<div class="kdf-reels__shop-row">' +
              "<p>Explore more products from this reel</p>" +
              '<a class="kdf-reels__open" href="/collections/all" rel="noopener">' +
              "Shop now</a></div>"
            : "";

        return (
          '<article class="kdf-reels__card" data-kdf-reel-card data-index="' +
          index +
          '" data-reel-id="' +
          String(item.id) +
          '" tabindex="0" aria-label="' +
          escapeAttr(title) +
          '">' +
          '<div class="kdf-reels__media">' +
          posterTag +
          "</div>" +
          '<div class="kdf-reels__shade" aria-hidden="true"></div>' +
          '<div class="kdf-reels__progress" aria-hidden="true"><span></span></div>' +
          '<span class="kdf-reels__badge" aria-hidden="true"><i></i> Reel</span>' +
          '<button type="button" class="kdf-reels__mute" data-kdf-mute aria-label="Unmute">' +
          iconMute(true) +
          "</button>" +
          '<button type="button" class="kdf-reels__tap" data-kdf-tap aria-label="Play or pause video"></button>' +
          '<div class="kdf-reels__playpulse" aria-hidden="true">' +
          iconPlay() +
          "</div>" +
          '<div class="kdf-reels__meta">' +
          '<p class="kdf-reels__reel-title">' +
          escapeHtml(title) +
          "</p>" +
          productBlock +
          catBlock +
          fallbackBlock +
          (!hasProduct ? '<div class="kdf-reels__product" data-kdf-product hidden></div>' : "") +
          "</div></article>"
        );
      })
      .join("");

    this.track.insertAdjacentHTML("beforeend", html);
    this.cards = qsa(this.track, "[data-kdf-reel-card]").map(function (el, index) {
      return new ReelCard(self, el, items[index]);
    });

    this.bindChrome();
    this.observe();
    this.hydrateProducts();
    this.updateActiveFromScroll();
  };

  KdfReels.prototype.bindChrome = function () {
    var self = this;
    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", function () {
        self.scrollByCards(-1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", function () {
        self.scrollByCards(1);
      });
    }
    this.track.addEventListener(
      "scroll",
      function () {
        if (self.raf) return;
        self.raf = requestAnimationFrame(function () {
          self.raf = 0;
          self.updateActiveFromScroll();
        });
      },
      { passive: true }
    );
  };

  KdfReels.prototype.scrollByCards = function (dir) {
    var card = this.cards[0] && this.cards[0].el;
    if (!card) return;
    var amount = card.getBoundingClientRect().width + 18;
    this.track.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  KdfReels.prototype.updateActiveFromScroll = function () {
    if (!this.cards.length) return;
    var trackRect = this.track.getBoundingClientRect();
    var mid = trackRect.left + trackRect.width / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < this.cards.length; i++) {
      var r = this.cards[i].el.getBoundingClientRect();
      var c = r.left + r.width / 2;
      var d = Math.abs(c - mid);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    }
    this.setActive(best);
    if (this.prevBtn) this.prevBtn.disabled = best <= 0;
    if (this.nextBtn) this.nextBtn.disabled = best >= this.cards.length - 1;
  };

  KdfReels.prototype.setActive = function (index) {
    if (index === this.activeIndex && this.cards[index] && this.cards[index].el.classList.contains("is-active")) {
      if (this.sectionInView !== false && this.cards[index]) this.cards[index].play();
      return;
    }
    this.activeIndex = index;
    for (var i = 0; i < this.cards.length; i++) {
      var card = this.cards[i];
      var on = i === index;
      card.el.classList.toggle("is-active", on);
      if (on && this.sectionInView !== false) card.play();
      else card.pause(true);
    }
  };

  KdfReels.prototype.pauseAll = function () {
    this.sectionInView = false;
    for (var i = 0; i < this.cards.length; i++) {
      this.cards[i].pause(true);
    }
  };

  KdfReels.prototype.resumeActive = function () {
    this.sectionInView = true;
    var card = this.cards[this.activeIndex];
    if (card) card.play();
  };

  KdfReels.prototype.observe = function () {
    var self = this;
    this.sectionInView = true;

    // Whole section off-screen (user scrolled up/down) → stop all videos
    if ("IntersectionObserver" in window) {
      this.sectionIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.18) {
              self.resumeActive();
            } else {
              self.pauseAll();
            }
          });
        },
        { root: null, threshold: [0, 0.18, 0.35] }
      );
      this.sectionIo.observe(this.root);
    }

    if (!("IntersectionObserver" in window)) {
      this.cards.forEach(function (c) {
        c.warm();
      });
      if (this.cards[0]) this.cards[0].play();
      return;
    }

    this.nearIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = parseInt(entry.target.getAttribute("data-index") || "0", 10);
          var card = self.cards[idx];
          if (!card) return;
          if (entry.isIntersecting) card.warm();
          else card.unloadFar();
        });
      },
      { root: null, rootMargin: "200px 120px", threshold: 0.01 }
    );

    this.io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = parseInt(entry.target.getAttribute("data-index") || "0", 10);
          var card = self.cards[idx];
          if (!card) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            if (idx === self.activeIndex && self.sectionInView !== false) card.play();
          } else {
            card.pause(true);
          }
        });
      },
      { root: this.track, threshold: [0.55, 0.75] }
    );

    this.cards.forEach(function (card) {
      self.nearIo.observe(card.el);
      self.io.observe(card.el);
    });
  };

  KdfReels.prototype.hydrateProducts = function () {
    var self = this;
    var queue = this.cards.filter(function (c) {
      return c.item.product && c.item.product.shopifyHandle;
    });
    var concurrency = 3;
    var i = 0;

    function next() {
      if (i >= queue.length) return;
      var batch = queue.slice(i, i + concurrency);
      i += concurrency;
      Promise.all(
        batch.map(function (card) {
          return card.hydrateProduct().catch(function () {
            card.hideProduct();
          });
        })
      ).then(next);
    }
    next();
  };

  KdfReels.prototype.setMuted = function (muted) {
    this.muted = !!muted;
    this.cards.forEach(function (c) {
      c.applyMute();
    });
    // User tapped unmute — resume active with sound
    var active = this.cards[this.activeIndex];
    if (active && this.sectionInView !== false) active.play();
  };

  function ReelCard(owner, el, item) {
    this.owner = owner;
    this.el = el;
    this.item = item;
    this.video = null;
    this.iframe = null;
    this.hls = null;
    this.warmed = false;
    this.playing = false;
    this.mediaMode = null;
    this.variantId = null;
    this.available = false;
    this.atcBusy = false;
    this.productIndex = 0;
    this.progressEl = qs(el, ".kdf-reels__progress > span");
    this.muteBtn = qs(el, "[data-kdf-mute]");
    this.tapBtn = qs(el, "[data-kdf-tap]");
    this.productEl = qs(el, "[data-kdf-product]");
    this.atcBtn = qs(el, "[data-kdf-atc]");
    this.buyBtn = qs(el, "[data-kdf-buy]");
    this._onTime = this.onTime.bind(this);
    this.bind();
  }

  ReelCard.prototype.bind = function () {
    var self = this;
    if (this.muteBtn) {
      this.muteBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.owner.setMuted(!self.owner.muted);
      });
    }
    if (this.tapBtn) {
      this.tapBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (self.playing) self.pause(false);
        else self.play();
      });
    }
    qsa(this.el, "[data-kdf-chip]").forEach(function (chip) {
      chip.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pi = parseInt(chip.getAttribute("data-pi") || "0", 10) || 0;
        self.selectProduct(pi);
      });
    });
    if (this.atcBtn) {
      this.atcBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.addToCart(false);
      });
    }
    if (this.buyBtn) {
      this.buyBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.addToCart(true);
      });
    }
    var productLink = qs(this.el, ".kdf-reels__product-link");
    if (productLink) {
      productLink.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }
  };

  ReelCard.prototype.selectProduct = function (index) {
    var products = this.item._products || [];
    if (!products[index]) return;
    this.productIndex = index;
    this.item.product = products[index];
    qsa(this.el, "[data-kdf-chip]").forEach(function (chip, i) {
      var on = i === index;
      chip.classList.toggle("is-on", on);
      chip.setAttribute("aria-selected", on ? "true" : "false");
    });
    if (this.productEl) {
      this.productEl.setAttribute("data-handle", products[index].shopifyHandle || "");
    }
    this.hydrateProduct();
  };

  ReelCard.prototype.applyMute = function () {
    var muted = this.owner.muted;
    if (this.video) {
      this.video.muted = muted;
      if (!muted) {
        try {
          this.video.volume = 1;
        } catch (e) {}
      }
    }
    if (this.iframe && this.item && this.item.playback && this.item.playback.cfStreamId) {
      var p = this.item.playback;
      var host = p.cfHost || "customer-1xj35z217cmgxlz0.cloudflarestream.com";
      var next =
        "https://" +
        host +
        "/" +
        p.cfStreamId +
        "/iframe?muted=" +
        (muted ? "true" : "false") +
        "&loop=true&autoplay=true&controls=false&preload=auto" +
        (p.poster ? "&poster=" + encodeURIComponent(p.poster) : "");
      if (this.iframe.getAttribute("src") !== next) this.iframe.setAttribute("src", next);
    }
    if (this.muteBtn) {
      this.muteBtn.setAttribute("aria-label", muted ? "Unmute" : "Mute");
      this.muteBtn.innerHTML = iconMute(muted);
    }
  };

  ReelCard.prototype.warm = function () {
    if (this.warmed) return;
    this.warmed = true;
    var self = this;
    var p = this.item.playback || {};
    var media = qs(this.el, ".kdf-reels__media");
    if (!media) return;

    // Lazy poster: only assign when near viewport
    var posterImg = qs(this.el, "img.kdf-reels__poster[data-src]");
    if (posterImg) {
      var ds = posterImg.getAttribute("data-src");
      if (ds) {
        posterImg.setAttribute("src", ds);
        posterImg.removeAttribute("data-src");
      }
    }

    var src = p.directVideoUrl || null;
    var preferIframe = false;
    var useHlsJs = false;
    // Adaptive streaming like Instagram/Facebook: hls.js plays the Cloudflare
    // HLS manifest in small segments at network-appropriate quality, instead of
    // one big progressive MP4. Falls back gracefully if the CDN is unreachable.
    if (!src && p.hlsUrl && typeof window.Hls !== "undefined" && window.Hls.isSupported()) {
      useHlsJs = true;
    } else if (!src && p.hlsUrl && canPlayHlsNatively(document.createElement("video"))) {
      // Prefer native video first so mute/unmute actually controls sound
      src = p.hlsUrl;
    } else if (!src && p.mp4Url) {
      src = p.mp4Url;
    } else if (!src && p.iframeUrl) {
      preferIframe = true;
    }

    if (preferIframe) {
      var iframe = document.createElement("iframe");
      iframe.className = "kdf-reels__iframe";
      iframe.setAttribute("allow", "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("loading", "lazy");
      iframe.setAttribute("title", this.item.title || "Reel");
      iframe.src = p.iframeUrl;
      media.appendChild(iframe);
      this.iframe = iframe;
      this.mediaMode = "iframe";
      this.el.classList.add("is-ready");
      return;
    }

    if (!src && !useHlsJs) return;
    var video = document.createElement("video");
    video.className = "kdf-reels__video";
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.muted = true;
    video.loop = true;
    video.preload = "metadata";
    video.setAttribute("poster", p.poster || "");
    if (!useHlsJs) video.src = src;
    media.appendChild(video);
    this.video = video;
    this.mediaMode = "video";

    if (useHlsJs) {
      try {
        var hls = new Hls({
          maxBufferLength: 12,
          maxMaxBufferLength: 24,
          manifestLoadingMaxRetry: 2,
          fragLoadingMaxRetry: 4,
          enableWorker: true,
        });
        this.hls = hls;
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          self.el.classList.add("is-ready");
        });
        hls.on(Hls.Events.ERROR, function (event, data) {
          if (!data || !data.fatal) return;
          /* HLS failed — fall back to the Cloudflare cloud player once */
          self.fallbackToIframe();
        });
        hls.loadSource(p.hlsUrl);
        hls.attachMedia(video);
      } catch (e) {
        this.hls = null;
        if (p.mp4Url) video.src = p.mp4Url;
      }
      video.addEventListener(
        "loadeddata",
        function () {
          self.el.classList.add("is-ready");
        },
        { once: true }
      );
      video.addEventListener("error", function () {
        self.fallbackToIframe();
      });
      return;
    }

    video.addEventListener(
      "loadeddata",
      function () {
        this.el.classList.add("is-ready");
      }.bind(this),
      { once: true }
    );
    video.addEventListener("error", function () {
      /* MP4 download may be disabled — fall back to the Cloudflare cloud player once */
      self.fallbackToIframe();
    });
  };

  // Last-resort playback: the Cloudflare Stream cloud player iframe, which
  // does its own adaptive streaming. Autoplay is on so a tap always plays.
  ReelCard.prototype.fallbackToIframe = function () {
    var p = this.item.playback || {};
    if (this.iframe || !p.iframeUrl) return;
    var media = qs(this.el, ".kdf-reels__media");
    if (!media) return;
    if (this.hls) {
      try {
        this.hls.destroy();
      } catch (e) {}
      this.hls = null;
    }
    if (this.video) {
      try {
        this.video.remove();
      } catch (e) {}
      this.video = null;
    }
    var iframe2 = document.createElement("iframe");
    iframe2.className = "kdf-reels__iframe";
    iframe2.setAttribute("allow", "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture");
    iframe2.setAttribute("allowfullscreen", "true");
    iframe2.setAttribute("loading", "lazy");
    iframe2.setAttribute("title", this.item.title || "Reel");
    iframe2.src = p.iframeUrl;
    media.appendChild(iframe2);
    this.iframe = iframe2;
    this.mediaMode = "iframe";
    this.el.classList.add("is-ready");
  };

  ReelCard.prototype.unloadFar = function () {
    if (this.el.classList.contains("is-active")) return;
    this.pause(true);
    if (this.hls) {
      try {
        this.hls.destroy();
      } catch (e) {}
      this.hls = null;
    }
    if (this.video) {
      try {
        this.video.removeAttribute("src");
        this.video.load();
        this.video.remove();
      } catch (e) {}
      this.video = null;
    }
    if (this.iframe) {
      try {
        this.iframe.src = "about:blank";
        this.iframe.remove();
      } catch (e) {}
      this.iframe = null;
    }
    this.warmed = false;
    this.el.classList.remove("is-ready", "is-playing");
  };

  ReelCard.prototype.play = function () {
    this.warm();
    this.el.classList.remove("is-paused");
    this.applyMute();
    if (this.video) {
      var self = this;
      /* Active reel buffers aggressively like Instagram — instant, stutter-free start.
         Skip when hls.js owns the buffer (it manages segments itself). */
      if (!this.hls && this.video.preload !== "auto") {
        try { this.video.preload = "auto"; } catch (e) {}
      }
      this.video.muted = this.owner.muted;
      var playPromise = this.video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
      this.video.addEventListener("timeupdate", this._onTime);
      this.playing = true;
      this.el.classList.add("is-playing");
      return;
    }
    if (this.iframe) {
      this.playing = true;
      this.el.classList.add("is-playing");
    }
  };

  ReelCard.prototype.pause = function (keepPosterState) {
    this.playing = false;
    this.el.classList.add("is-paused");
    if (!keepPosterState) {
      /* user paused */
    } else {
      this.el.classList.remove("is-paused");
    }
    if (this.video) {
      try {
        this.video.pause();
      } catch (e) {}
      this.video.removeEventListener("timeupdate", this._onTime);
    }
    if (keepPosterState) this.el.classList.remove("is-playing");
  };

  ReelCard.prototype.onTime = function () {
    if (!this.video || !this.progressEl || !this.video.duration) return;
    var pct = (this.video.currentTime / this.video.duration) * 100;
    this.progressEl.style.width = Math.max(0, Math.min(100, pct)) + "%";
  };

  ReelCard.prototype.hideProduct = function () {
    if (this.productEl) this.productEl.hidden = true;
  };

  ReelCard.prototype.hydrateProduct = function () {
    var self = this;
    var handle = this.item.product && this.item.product.shopifyHandle;
    if (!handle || !this.productEl) return Promise.resolve();
    return loadProduct(handle).then(function (product) {
      var variant = pickVariant(product);
      if (!variant) {
        self.hideProduct();
        return;
      }
      self.variantId = variant.id;
      self.available = !!variant.available;
      var img = qs(self.el, "[data-kdf-product-img]");
      var name = qs(self.el, "[data-kdf-product-name]");
      var price = qs(self.el, "[data-kdf-price]");
      var compare = qs(self.el, "[data-kdf-compare]");
      var variantEl = qs(self.el, "[data-kdf-variant]");
      var src = productImage(product, self.item.product.image || "");
      if (img && src) {
        img.src = src.indexOf("//") === 0 ? "https:" + src : src;
        img.alt = product.title || handle;
      }
      if (name) {
        name.textContent = product.title || handle;
      }
      var productLink = qs(self.el, ".kdf-reels__product-link");
      if (productLink) productLink.href = "/products/" + encodeURIComponent(handle);
      if (price) price.textContent = money(variant.price);
      if (compare) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          compare.hidden = false;
          compare.textContent = money(variant.compare_at_price);
        } else {
          compare.hidden = true;
        }
      }
      if (variantEl) {
        variantEl.textContent = variant.title && variant.title !== "Default Title" ? variant.title : "";
      }
      if (self.atcBtn) {
        if (!self.available) {
          self.atcBtn.disabled = true;
          self.atcBtn.textContent = "Sold out";
          if (self.buyBtn) {
            self.buyBtn.disabled = true;
            self.buyBtn.hidden = true;
          }
        } else {
          self.atcBtn.disabled = false;
          self.atcBtn.textContent = shortAtcLabel(self.item.ctaLabel);
          if (self.buyBtn) {
            self.buyBtn.disabled = false;
            self.buyBtn.hidden = false;
            self.buyBtn.textContent = "Buy";
          }
        }
      }
      self.productEl.hidden = false;
    });
  };

  ReelCard.prototype.addToCart = function (buyNow) {
    var self = this;
    if (this.atcBusy || !this.variantId || !this.available) return;
    this.atcBusy = true;
    var btn = buyNow ? this.buyBtn : this.atcBtn;
    if (!btn) {
      this.atcBusy = false;
      return;
    }
    var original = btn.textContent;
    btn.disabled = true;
    if (this.atcBtn) this.atcBtn.disabled = true;
    if (this.buyBtn) this.buyBtn.disabled = true;
    btn.textContent = buyNow ? "Please wait…" : "Adding…";

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: this.variantId, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        if (buyNow) {
          window.location.href = root + "checkout";
          return null;
        }
        return fetch(root + "cart.js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        }).then(function (r) {
          return r.ok ? r.json() : null;
        });
      })
      .then(function (cart) {
        if (buyNow) return;
        try {
          document.dispatchEvent(new CustomEvent("kdf:cart:updated", { detail: cart || {} }));
        } catch (e) {}
        btn.textContent = "Added";
        btn.classList.add("is-success");
        openCartDrawer();
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove("is-success");
          if (self.atcBtn) self.atcBtn.disabled = false;
          if (self.buyBtn) self.buyBtn.disabled = false;
          self.atcBusy = false;
        }, 1200);
      })
      .catch(function () {
        btn.textContent = "Try again";
        if (self.atcBtn) self.atcBtn.disabled = false;
        if (self.buyBtn) self.buyBtn.disabled = false;
        self.atcBusy = false;
        setTimeout(function () {
          btn.textContent = original;
        }, 1500);
      });
  };

  function shortAtcLabel(label) {
    var t = String(label || "Add").trim();
    if (!t) return "Add";
    if (/add\s*to\s*cart/i.test(t) || t.length > 10) return "Add";
    return t;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, "&#39;");
  }

  function iconMute(muted) {
    if (muted) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M23 9l-6 6M17 9l6 6"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>';
  }

  function iconPlay() {
    return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  }

  function boot() {
    qsa(document, "[data-kdf-reels]").forEach(function (root) {
      if (root.getAttribute("data-kdf-reels-booted")) return;
      root.setAttribute("data-kdf-reels-booted", "1");
      var inst = new KdfReels(root);
      // Start immediately: the skeleton already reserves layout and the fetch
      // is async. Deferring to idle delayed content by up to 3.5s on busy pages.
      inst.init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
